import React from "react";
import moment from "moment";
import { Image, Table, Tag } from "antd";

const SalesExpenceTable = (props) => {
  const columns = [
    {
      title: "DATE",
      dataIndex: "date",
      key: "date",
      render: (text, record) => {
        return <div>{moment.utc(record?.date).format("DD-MM-YYYY")}</div>;
      },
      width: 150,
    },
    {
      title: "EXPENSES",
      dataIndex: "expense",
      key: "expense",
      render: (text, record) => <div>{record?.head}</div>,
    },
    {
      title: "NOTE",
      dataIndex: "note",
      key: "note",
      render: (text, record) => <div>{record?.note}</div>,
    },
    {
      title: "AMOUNT",
      dataIndex: "rate",
      key: "rate",
      render: (text, record) => <div>{record?.amount}</div>,
    },

    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      render: (text, record) => (
        <Image src={record?.image} alt="" height={80} width={100} />
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text, record) => <Tag>{record?.status}</Tag>,
    },
    {
      title: "EXPENSE BY",
      dataIndex: "expance_user",
      key: "expance_user",
      render: (text, record) => <div>{record?.expance_user?.name}</div>,
    },
  ];

  return (
    <div>
      <Table
        rowClassName={(record, index) =>
          index % 2 === 0 ? "table-row-light" : "table-row-dark"
        }
        columns={columns}
        dataSource={props?.expense}
        pagination={true}
        size="small"
        rowKey={(record) => record.id}
      />
    </div>
  );
};

export default SalesExpenceTable;
